import template from './internalErrors.html';
import './style.scss';

export default {
  template,
};
